import { Datagrid, EditButton, List, ShowButton, TextField, TextInput } from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import { ListActions } from "../../common/ListActions";

export function FormatList(): JSX.Element {
    const filters = [<TextInput key="searchTerms-id" source="id" />];

    return (
        <>
            <List hasCreate pagination={<ListPagination />} perPage={20} filters={filters} actions={<ListActions />}>
                <Datagrid rowStyle={rowStyles}>
                    <TextField source="name" />
                    <TextField source="description" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            </List>
        </>
    );
}
